import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface Heart {
  id: number;
  x: number;
  y: number;
}

export const NeonHeartTrail = () => {
  const [hearts, setHearts] = useState<Heart[]>([]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    let heartId = 0;
    let lastTime = Date.now();
    const minInterval = 50; // milliseconds between hearts

    const handleMouseMove = (e: MouseEvent) => {
      const currentTime = Date.now();

      setMousePosition({ x: e.clientX, y: e.clientY });

      if (currentTime - lastTime > minInterval) {
        const newHeart: Heart = {
          id: heartId++,
          x: e.clientX,
          y: e.clientY,
        };

        setHearts((prev) => [...prev, newHeart]);

        setTimeout(() => {
          setHearts((prev) => prev.filter((h) => h.id !== newHeart.id));
        }, 1500);

        lastTime = currentTime;
      }
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 z-50">
      <AnimatePresence>
        {hearts.map((heart) => (
          <motion.div
            key={heart.id}
            initial={{
              x: heart.x - 12,
              y: heart.y - 12,
              scale: 0.8,
              opacity: 1,
            }}
            animate={{
              x: heart.x - 12 + (Math.random() - 0.5) * 60,
              y: heart.y - 12 - Math.random() * 80,
              scale: 0.3,
              opacity: 0,
              rotate: (Math.random() - 0.5) * 45,
            }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 1.2,
              ease: "easeOut",
            }}
            className="absolute"
            style={{
              width: "24px",
              height: "24px",
              filter:
                "drop-shadow(0 0 8px #dc2626) drop-shadow(0 0 12px #dc2626)",
            }}
          >
            {/* SVG Heart */}
            <svg
              viewBox="0 0 24 24"
              fill="#dc2626"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                filter: "brightness(1.2)",
              }}
            >
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};
